<template>
  <div v-if="showComponent">
    <div class="vx-row mt-5">
      <!-- Status do Evento -->
      <div class="vx-col lg:w-1/3 w-full mb-2">
        <label class="vs-select--label">Status do Sinistro</label>
        <v-select
          class="selectStyle"
          :options="listSituacoes"
          name="Status do Evento"
          id="Status do Evento"
          v-model="formCadastroPatrimonio.idStatus"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>
      <!-- Analista Responsável -->
      <div class="vx-col lg:w-1/3 w-full mb-2">
        <label for="Analista Responsável Evento" class="vs-select--label"
          >Analista Responsável Patrimônio</label
        >
        <v-select
          :options="dominios.listResponsaveis"
          v-model="formCadastroPatrimonio.idAnalista"
          name="Analista Responsável Evento"
          id="Analista Responsável Evento"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>
      <!-- Regulador Responsável -->
      <div class="vx-col lg:w-1/3 w-full mb-2">
        <label for="Regulador Responsavel Evento" class="vs-select--label"
          >Regulador Responsável Patrimônio</label
        >
        <v-select
          :options="dominios.listResponsaveis"
          v-model="formCadastroPatrimonio.idRegulador"
          name="Regulador Responsavel Evento"
          id="Regulador Responsavel Evento"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>
    </div>

    <!-- Descrição do Evento para Controle Interno -->
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vs-textarea
          label="Descrição do Evento para Controle Interno"
          v-model="formCadastroPatrimonio.descricaoEventoControleInterno"
        />
      </div>
    </div>

    <!-- Observações -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <span class="vs-input--label">Observações</span>
        <vue-editor
          v-model="formCadastroPatrimonio.observacao"
          :editor-toolbar="customToolbar"
        ></vue-editor>
      </div>
    </div>

    <HistoricoObservacao :historicos="formCadastroPatrimonio.historicos" />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { VueEditor } from 'vue2-editor';
import customToolbar from './../../../../../components/editor/config';

import HistoricoObservacao from './../../shared/components/HistoricoObservacao.vue';

export default {
  props: ['formData', 'dominios'],
  components: {
    vSelect,
    HistoricoObservacao,
    VueEditor,
  },
  watch: {
    formData(value) {
      if (!value.cadastroPatrimonio) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - CADASTRO PATRIMONIO FORM');
        return;
      }

      this.formCadastroPatrimonio = Object.assign(
        this.formCadastroPatrimonio,
        value.cadastroPatrimonio,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cadastroPatrimonio = this.formCadastroPatrimonio;
    },
  },
  data() {
    return {
      showComponent: true,
      formCadastroPatrimonio: {
        idStatus: null,
        idAnalista: null,
        idRegulador: null,
        descricaoEventoControleInterno: null,
        observacao: null,
        historicos: [],
      },
      listSituacoes: [],

      // Configurações de Component
      customToolbar,
    };
  },
  mounted() {
    if (!this.formData.cadastroPatrimonio) {
      console.error('ERRO NO CONTRATO DO OBJETO - CADASTRO PATRIMONIO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.formCadastroPatrimonio = this.formcadastroPatrimonio;

    this.listSituacoes = this.dominios.listSituacoes;
  },
};
</script>

<style src="./../../../../../components/editor/style-editor.css"></style>
